export default {
  subtitle:
    "Tiefgehende Analyse der EU-CBAM-Kohlenstoffcompliance, um KMU bei der schnellen Erfassung von Vorschriften und Markttrends zu unterstützen",
  feature1: "CBAM-Einführung",
  feature2: "Compliance-Prozess",
  feature3: "Markttrends",
  feature4: "Wie unser Produkt Unternehmen hilft",
  seo_title: "Leitfaden zur EU-CBAM-Kohlenstoffcompliance",
  section1_title: "CBAM-Einführung",
  section1_content1:
    "Der EU Carbon Border Adjustment Mechanism (CBAM) ist ein wichtiges politisches Instrument, das die EU zur Bekämpfung des Klimawandels eingeführt hat.",
  section1_content2:
    "Dieser Mechanismus zielt darauf ab, Kohlenstofflecks zu verhindern und sicherzustellen, dass importierte Waren in einem fairen Wettbewerbsumfeld mit innerhalb der EU produzierten Waren stehen, was die Kohlenstoffemissionskosten betrifft.",
  section1_content3:
    "CBAM verlangt von Importeuren bestimmter kohlenstoffintensiver Waren in die EU, die entsprechenden Kohlenstoffemissionszertifikate zu kaufen, die den von EU-Herstellern getragenen Kohlenstoffkosten entsprechen.",
  section2_title: "Compliance-Prozess",
  section2_content: "Der CBAM-Compliance-Prozess umfasst vier Schlüsselschritte:",
  section2_step1:
    "Deklaration: Importeure müssen sich im CBAM-System registrieren und regelmäßig die Kohlenstoffemissionen importierter Waren deklarieren",
  section2_step2:
    "Verifizierung: Die deklarierten Kohlenstoffemissionsdaten müssen von einer unabhängigen Prüfungsagentur verifiziert werden",
  section2_step3:
    "Zertifikatkauf: Kauf der entsprechenden CBAM-Zertifikate basierend auf den verifizierten Emissionsdaten",
  section2_step4:
    "Zoll: Waren können erst nach Abschluss des CBAM-Zertifikatkaufs auf den EU-Markt gelangen",
  section3_title: "Markttrends",
  section3_content:
    "CBAM entwickelt und erweitert sich kontinuierlich weiter, mit folgenden Haupttrends:",
  section3_trend1:
    "Umfangserweiterung: CBAM wird schrittweise auf weitere Industrien ausgeweitet, einschließlich organischer Chemikalien und Kunststoffprodukten",
  section3_trend2:
    "Strengere Standards: Die EU wird weiterhin die Anforderungen an Genauigkeit und Transparenz bei der Kohlenstoffemissionszählung verbessern",
  section3_trend3:
    "Globale Auswirkungen: CBAM drängt globale Handelspartner dazu, eigene Kohlenstoffpreismechanismen einzurichten oder anzupassen",
  section3_trend4:
    "Technologieentwicklung: Digitale Tools und automatisierte Systeme spielen eine zunehmend wichtige Rolle bei der Kohlenstoffemissionszählung",
  section4_title: "Wie unser Produkt Unternehmen hilft",
  section4_content:
    "Unser Produkt kann Unternehmen dabei helfen, die CBAM-Compliance-Anforderungen effektiv zu erfüllen:",
  section4_benefit1:
    "Genaue Berechnungen: Bietet präzise Kohlenstoffemissionsberechnungen basierend auf offiziellen EU-Faktoren und benutzerdefinierten Faktoren",
  section4_benefit2:
    "Effiziente Compliance: Generiert automatisch CBAM-konforme Berichte und vereinfacht den Deklarationsprozess",
  section4_benefit3:
    "Batch-Verarbeitung: Unterstützt die Verarbeitung großer Datenmengen zur Verbesserung der Arbeits-effizienz",
  section4_benefit4:
    "API-Integration: Integriert sich einfach in ERP- und E-Commerce-Systeme für automatisierte Compliance-Berichterstattung",
  download_title: "Whitepaper jetzt herunterladen",
  email_placeholder: "Bitte geben Sie Ihre E-Mail-Adresse ein",
  agreement_text:
    "Ich stimme zu, diese E-Mail zu verwenden, um das Whitepaper zu erhalten, und stimme der Verarbeitung meiner personenbezogenen Daten gemäß den DSGVO-Anforderungen zu.",
  privacy_policy: "Datenschutzrichtlinie anzeigen",
  download_button: "Whitepaper herunterladen (PDF)",
  download_generating: "Wird generiert...",
  email_required: "Bitte geben Sie Ihre E-Mail-Adresse ein",
  agreement_required: "Bitte stimmen Sie der Datenschutzrichtlinie zu",
  download_success:
    "Whitepaper erfolgreich heruntergeladen, danke für die Nutzung unseres Dienstes!",
  download_failed: "Download fehlgeschlagen, bitte versuchen Sie es später erneut",
  submit_error: "Senden fehlgeschlagen, bitte versuchen Sie es später erneut",
};
